export default "__VITE_ASSET__C8A9DI32__"